import axios from "axios";

type CachedUrlEntry = {
  url: string;
  expiresAt: number;
};

const preSignedUrlCache: Record<string, CachedUrlEntry> = {};
const API_URL = process.env.REACT_APP_API_URL;

export const uploadResource = async (
  path: string,
  resource: any,
  resource_type: any,
  onProgress?: (percent: number) => void
) => {
  const cacheKey = `${path}|${resource_type}`;
  const now = Date.now();

  let cachedUrl = preSignedUrlCache[cacheKey];

  if (!cachedUrl || now > cachedUrl.expiresAt) {
    try {
      const response = await axios.get(`${API_URL}/utils/upload-url`, {
        params: {
          path: path,
          content_type: resource_type,
        },
        withCredentials: true,
      });

      const url = response.data;
      const expiresIn = 3600;
      const expiresAt = now + expiresIn * 1000;

      cachedUrl = { url, expiresAt };
      preSignedUrlCache[cacheKey] = cachedUrl;
    } catch (error: any) {
      if (axios.isAxiosError(error) && error.response?.status === 401) {
        window.location.href = "/sign-in";
        return;
      } else {
        throw error; 
      }
    }
  }

  await axios.put(cachedUrl.url, resource, {
    headers: {
      'Content-Type': resource_type,
      ...(resource_type === "application/json" && { 'Cache-Control': 'no-store' }),
    },
    onUploadProgress: (progressEvent) => {
      if (progressEvent.total) {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        onProgress?.(percentCompleted);
      }
    },
  });
};
